
import React from "react";
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { checkLocalStorage } from '../auth/localStorage';

// React Router v6+ compatible
const PrivateRoute = ({ element }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const auth = useAuth();

    let app_name = 'Roster';
    if (window.location.href.includes('lessons')) {
        app_name = 'Lessons Learned';
    }
    let form_html = '';
    if (app_name === 'Lessons Learned') {
        form_html = `<div data-tf-popover=\"qyj6Y6od\" data-tf-custom-icon=\"https://images.typeform.com/images/wiBmeQ5kFu8M\" data-tf-opacity=\"100\" data-tf-iframe-props=\"title=AMI Tool Feedback\" data-tf-transitive-search-params data-tf-button-color=\"#FFFFFF\" data-tf-medium=\"snippet\" data-tf-hidden=\"utm_source={{${localStorage.getItem('email')}}},product={{product|default:'lessonslearned'}}\" style=\"all:unset;\"></div>`;
    } else {
        form_html = `<div data-tf-popover=\"qyj6Y6od\" data-tf-custom-icon=\"https://images.typeform.com/images/wiBmeQ5kFu8M\" data-tf-opacity=\"100\" data-tf-iframe-props=\"title=AMI Tool Feedback\" data-tf-transitive-search-params data-tf-button-color=\"#FFFFFF\" data-tf-medium=\"snippet\" data-tf-hidden=\"utm_source={{${localStorage.getItem('email')}}},product={{product|default:'roster'}}\" style=\"all:unset;\"></div>`;
    }

    React.useEffect(() => {
        const script = document.createElement('script');
        script.src = "//embed.typeform.com/next/embed.js";
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    if (isLoading) {
        return <>Loading...</>;
    }
    checkLocalStorage();

    // Only render if authenticated
    if (isAuthenticated) {
        return (
            <>
                <div dangerouslySetInnerHTML={{ __html: form_html }} />
                {React.cloneElement(element, { auth })}
            </>
        );
    } else {
        try {
            const intendedPath = window.location.pathname + window.location.search;
            if (intendedPath !== '/') {
                sessionStorage.setItem('postLoginRedirect', intendedPath);
            }
        } catch { /* private browsing fallback */ }
        return <Navigate to="/" replace />;
    }
};

export default PrivateRoute;